import moment from 'moment'
import { beforeEqualToday, cns, cpf, createValidator, ErrorObject, hora, required } from 'util/validation'

import AtestadoModel from '../components/model-atestado'

export const atestadoPadraoFormValidator = (possuiCpfCns: string, dataAtendimento: number) =>
  createValidator<AtestadoModel>(
    {
      data: [required, beforeEqualToday],
      hora: [required, hora],
      dias: [required],
    },
    (values: AtestadoModel, errors: ErrorObject<AtestadoModel>) => {
      if (!errors.dias && values.dias <= 0) {
        errors.dias = 'Deve ter valor entre 1 e 999.'
      }

      const minDate = moment(dataAtendimento).subtract(90, 'd').format('YYYY-MM-DD')
      if (!errors.data && moment(values.data).isBefore(minDate)) {
        errors.data = 'Limite de 90 dias anteriores à data do atendimento.'
      } else if (moment(values.data).isAfter(moment(dataAtendimento))) {
        errors.data = 'Deve ser anterior ou igual à data do atendimento.'
      }

      if (!errors.cpfCns && !values.naoPossui && !possuiCpfCns) {
        errors.cpfCns = required(values.cpfCns)

        const [lengthCpf, cpfRule] = cpf
        const [lengthCns, cnsRule] = cns

        if (values?.cpfCns) {
          if (lengthCpf && cpfRule(values.cpfCns) && lengthCns && cnsRule(values.cpfCns)) {
            errors.cpfCns = 'CPF/CNS inválido.'
          }
        }
      }

      return errors
    }
  )
